export default ({ request }) => ({
  ecomHxSkuPlatformListingListApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/platform/listing',
      method: 'post',
      data,
    })
  },
  ecomHxSkuPlatformPutShelvesApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/platform/putShelves',
      method: 'post',
      data,
    })
  },
  ecomHxSkuPlatformListingDetailApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/platform/listing/detail',
      method: 'post',
      data,
    })
  },
  ecomHxSkuPlatformListingSaveApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/platform/listing/save',
      method: 'post',
      data,
    })
  },
  ecomHxSkuPlatformUnsaleableApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/platform/unsaleable',
      method: 'post',
      data,
    })
  },
  ecomHxSkuPlatformAvailableSaleApi(data = {}) {
    return request({
      url: '/ecom/hx/sku/platform/availableSale',
      method: 'post',
      data,
    })
  },
})
